var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg041Share(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7BAB"
    },
    d: "M395.158,434.445c-3.01,0-6.058-0.766-8.852-2.379L107.956,271.36 c-5.488-3.168-8.868-9.024-8.868-15.36c0-6.337,3.38-12.191,8.868-15.36L386.307,79.934c8.481-4.894,19.331-1.992,24.227,6.492 c4.898,8.483,1.992,19.33-6.491,24.228L152.295,256l251.747,145.346c8.483,4.898,11.389,15.745,6.491,24.228 C407.249,431.264,401.287,434.445,395.158,434.445z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M217.257,293.505L152.295,256l64.961-37.505 c-4.213-11.244-10.257-21.6-17.776-30.696l-91.525,52.842c-5.488,3.168-8.868,9.023-8.868,15.36c0,6.336,3.38,12.192,8.868,15.36 l91.525,52.842C207,315.105,213.044,304.749,217.257,293.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M404.043,401.346l-91.526-52.842 c-7.519,9.097-13.563,19.453-17.776,30.697l91.565,52.865c2.793,1.613,5.842,2.379,8.852,2.379c6.129,0,12.091-3.181,15.375-8.871 C415.432,417.091,412.526,406.244,404.043,401.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M312.517,163.496l91.526-52.842 c8.483-4.898,11.389-15.744,6.491-24.228c-4.897-8.484-15.746-11.386-24.227-6.492l-91.565,52.865 C298.954,144.043,304.998,154.399,312.517,163.496z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7F9AE6"
    },
    cx: 116.829,
    cy: 256,
    r: 87.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E38892"
    },
    cx: 60.861,
    cy: 266.81,
    rx: 20.649,
    ry: 16.444
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E38892"
    },
    cx: 172.789,
    cy: 266.81,
    rx: 20.649,
    ry: 16.444
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E38892"
    },
    cx: 395.179,
    cy: 416.71,
    r: 87.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 339.209,
    cy: 427.51,
    rx: 20.649,
    ry: 16.444
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 451.139,
    cy: 427.51,
    rx: 20.649,
    ry: 16.444
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8E47C"
    },
    cx: 395.179,
    cy: 95.29,
    r: 87.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E38892"
    },
    cx: 339.209,
    cy: 106.1,
    rx: 20.649,
    ry: 16.444
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E38892"
    },
    cx: 451.139,
    cy: 106.1,
    rx: 20.649,
    ry: 16.444
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#254A74",
      enableBackground: "new"
    },
    d: "M82.861,175.022C51.239,188.301,29.03,219.555,29.03,256 c0,48.487,39.307,87.794,87.794,87.794c26.351,0,49.972-11.625,66.065-30.008C43.681,330.168,36.492,223.912,82.861,175.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#8C6023",
      enableBackground: "new"
    },
    d: "M361.211,14.316C329.59,27.595,307.38,58.849,307.38,95.294 c0,48.487,39.307,87.794,87.794,87.794c26.351,0,49.972-11.625,66.065-30.007C322.031,169.462,314.843,63.206,361.211,14.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#812B2F",
      enableBackground: "new"
    },
    d: "M361.211,335.728 c-31.621,13.279-53.831,44.532-53.831,80.978c0,48.488,39.307,87.794,87.794,87.794c26.351,0,49.972-11.625,66.065-30.008 C322.031,490.874,314.843,384.618,361.211,335.728z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.246,396.315c-4.143,0-7.5,3.358-7.5,7.5v7.291c0,4.142,3.357,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-7.291 C358.746,399.672,355.389,396.315,351.246,396.315z M343.746,82.403v7.292c0,4.142,3.357,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5 v-7.292c0-4.142-3.358-7.5-7.5-7.5C347.103,74.903,343.746,78.261,343.746,82.403z M80.395,250.4v-7.292c0-4.142-3.357-7.5-7.5-7.5 c-4.143,0-7.5,3.358-7.5,7.5v7.292c0,4.142,3.357,7.5,7.5,7.5C77.038,257.9,80.395,254.542,80.395,250.4z M411.684,405.776 c-3.121-2.722-7.86-2.398-10.581,0.726c-1.498,1.718-3.659,2.704-5.929,2.704c-2.268,0-4.43-0.986-5.928-2.704 c-2.721-3.122-7.46-3.448-10.581-0.726c-3.123,2.722-3.447,7.46-0.726,10.582c4.347,4.987,10.629,7.848,17.234,7.848 c6.607,0,12.889-2.86,17.235-7.848C415.131,413.235,414.807,408.498,411.684,405.776z M401.102,85.09 c-1.497,1.718-3.658,2.704-5.928,2.704c-2.268,0-4.43-0.986-5.927-2.704c-2.723-3.123-7.461-3.448-10.582-0.726 c-3.123,2.721-3.447,7.459-0.726,10.581c4.348,4.988,10.63,7.849,17.235,7.849c6.607,0,12.889-2.861,17.236-7.849 c2.721-3.123,2.396-7.86-0.727-10.581C408.562,81.642,403.823,81.968,401.102,85.09z M116.824,263.5 c6.605,0,12.888-2.861,17.235-7.849c2.721-3.123,2.396-7.86-0.727-10.582c-3.123-2.723-7.859-2.396-10.582,0.726 c-1.497,1.718-3.658,2.704-5.927,2.704c-2.27,0-4.431-0.986-5.928-2.704c-2.722-3.123-7.46-3.448-10.582-0.726 c-3.123,2.721-3.447,7.459-0.727,10.582C103.936,260.639,110.218,263.5,116.824,263.5z M168.252,250.4v-7.292 c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v7.292c0,4.142,3.357,7.5,7.5,7.5C164.894,257.9,168.252,254.542,168.252,250.4z  M395.174,321.412c-26.055,0-49.698,10.515-66.918,27.519l-119.227-68.836c2.013-7.699,3.089-15.773,3.089-24.095 c0-8.322-1.075-16.396-3.089-24.095l119.227-68.835c17.22,17.004,40.863,27.519,66.918,27.519c52.546,0,95.295-42.749,95.295-95.294 c0-20.026-6.143-39.191-17.767-55.423c-2.411-3.369-7.098-4.143-10.464-1.732c-3.368,2.412-4.144,7.097-1.731,10.464 c9.788,13.671,14.962,29.816,14.962,46.691c0,44.274-36.021,80.294-80.295,80.294s-80.294-36.02-80.294-80.294 S350.899,15,395.174,15c14.827,0,29.31,4.071,41.882,11.773c3.531,2.163,8.149,1.055,10.313-2.477s1.055-8.149-2.477-10.314 C429.96,4.835,412.769,0,395.174,0c-52.545,0-95.294,42.749-95.294,95.294c0,8.321,1.075,16.396,3.089,24.095l-119.227,68.835 c-17.22-17.004-40.863-27.519-66.917-27.519c-52.546,0-95.295,42.749-95.295,95.294c0,22.323,7.878,44.03,22.182,61.122 c2.659,3.177,7.389,3.596,10.565,0.938c3.177-2.658,3.597-7.388,0.938-10.565C43.165,293.097,36.529,274.809,36.529,256 c0-44.274,36.02-80.294,80.295-80.294s80.294,36.02,80.294,80.294s-36.02,80.294-80.294,80.294c-12.998,0-25.398-3.007-36.854-8.937 c-3.677-1.902-8.205-0.466-10.108,3.213c-1.904,3.679-0.466,8.204,3.212,10.108c13.417,6.945,28.545,10.616,43.75,10.616 c26.055,0,49.698-10.515,66.918-27.52l119.226,68.836c-2.013,7.699-3.089,15.773-3.089,24.095c0,52.545,42.749,95.294,95.294,95.294 c52.546,0,95.295-42.749,95.295-95.294S447.72,321.412,395.174,321.412z M193.72,199.784l114.294-65.987 c2.79,6.29,6.241,12.223,10.265,17.713l-114.294,65.988C201.195,211.207,197.743,205.274,193.72,199.784z M193.72,312.215 c4.024-5.49,7.475-11.423,10.264-17.713l114.294,65.988c-4.024,5.489-7.475,11.422-10.265,17.713L193.72,312.215z M395.174,497 c-44.274,0-80.294-36.02-80.294-80.294s36.02-80.294,80.294-80.294s80.295,36.02,80.295,80.294S439.448,497,395.174,497z  M439.102,396.315c-4.143,0-7.5,3.358-7.5,7.5v7.291c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-7.291 C446.602,399.672,443.245,396.315,439.102,396.315z M439.102,74.903c-4.143,0-7.5,3.358-7.5,7.5v7.292c0,4.142,3.357,7.5,7.5,7.5 s7.5-3.358,7.5-7.5v-7.292C446.602,78.261,443.245,74.903,439.102,74.903z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg041Share);
export default __webpack_public_path__ + "static/media/041-share.5f01f4cffb46efb177e114dc8def6337.svg";
export { ForwardRef as ReactComponent };